import React from 'react';
import ConfirmDialog from '../../components/confirm-dialog';
import { useSnackbar } from '../../components/toast';
import { ARCHIVE_CONVERSATION_FAILED, ARCHIVE_CONVERSATION_SUCCESS, UNARCHIVE_CONVERSATION_FAILED, UNARCHIVE_CONVERSATION_SUCCESS } from '../../helpers/messages';
import Utils from '../../utils';

/**
 * setArchiveState = true
 * To archive the conversation
 * 
 * setArchiveState = false
 * To un-archive the conversation
 */

const ChangeArchiveConfirm = ({ setArchiveState, open, data, onClose, onSuccess }) => {
    const [isLoading, setIsLoading] = React.useState(null);
    const showSnackbar = useSnackbar();

    // update the conversation archive status API
    const onConfirm = async () => {
        try {
            setIsLoading(true)
            const _data = data.filter((a) => a.selected).map((a) => a.id);
            async function convertToArchive(conversationId) {
                return await Utils.genericMutation("updateConversation", {
                    id: conversationId,
                    archive: setArchiveState,
                });
            }
            await Promise.all(_data.map(convertToArchive));
            setIsLoading(false);
            onSuccess();
            showSnackbar(setArchiveState ? ARCHIVE_CONVERSATION_SUCCESS : UNARCHIVE_CONVERSATION_SUCCESS);
        } catch (error) {
            console.log(error);
            setIsLoading(false)
            showSnackbar(setArchiveState ? ARCHIVE_CONVERSATION_FAILED : UNARCHIVE_CONVERSATION_FAILED, "error");
        }
    };


    return (<ConfirmDialog
        open={open}
        loading={isLoading}
        onClose={onClose}
        onConfirm={onConfirm}
        title={setArchiveState ? "Archive Conversions": "Unarchive Conversions"}
        okText='Ok'
        message={`Are you sure you want to ${setArchiveState ? "archive": "unarchive"} the conversation(s)?`}
    />)
}

export default ChangeArchiveConfirm